'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSmsThread } from '../../Entities/User/UserSmsThread';
import { UserSmsThreadCollection } from '../../Collections/User/UserSmsThreadCollection';

export class UserSmsThreadRepository extends CoreRepository {
  public getUserIndSmsThread(
    userId: number,
    indId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserIndSmsThread(userId, indId, options).then((response) => {
      const collection = new UserSmsThreadCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserSmsThread();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public moveUserIndSmsThreads(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.moveUserIndSmsThreads(userId, individualId, payload).then((response) => {
      return response;
    });
  }
}
